module.exports = __webpack_public_path__ + "img/examples-ru-9.b94a79d2.jpg";